import React from 'react'

export default function Clock() {
    return (
        <div>
            <svg width="112" height="112" viewBox="0 0 112 112" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M56 108.5C84.9949 108.5 108.5 84.9949 108.5 56C108.5 27.0051 84.9949 3.5 56 3.5C27.0051 3.5 3.5 27.0051 3.5 56C3.5 84.9949 27.0051 108.5 56 108.5Z" stroke="black" stroke-width="7" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M56 55.9999L73.5 67.6666M56 26.8333V55.9999" stroke="black" stroke-width="7" stroke-linecap="round" stroke-linejoin="round" />
            </svg>

        </div>
    )
}
